function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24.79c6.63 0 12-5.37 12-12s-5.37-12-12-12-12 5.37-12 12 5.37 12 12 12z",
  fill: "#4C4849"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.95 18.87c2.29 0 4.16-1.33 4.16-4.58V8.85l1.36-.91h-4.03l1.5.91v5.38c0 3.1-2.03 3.52-2.98 3.52-.95 0-2.82-.43-2.82-3.52V8.9l1.36-.96H5.76l1.38.96v3.95l-1.86.3v.89l1.86-.3v.43l-1.86.3v.89l1.87-.3c.1 2.99 2.55 3.81 4.8 3.81zm6.77-7.13v-.89l-1.76.28V9.26l1.07-.69-.29-.31-1.2.79s-.03 1.47-.03 5.41c0 3.94-3.01 4.8-4.32 4.8-.12 0-.25 0-.4.01-1.16.04-2.92.09-4.53-1.93 1.01 1.78 2.61 2.3 4.9 2.3 2.4 0 4.8-1.68 4.8-5.14v-1.15l1.76-.28v-.89l-1.76.28v-.43l1.76-.29zm-6.5 5.42c-1.84 0-2.69-1.04-2.69-2.88 0-2.53.02-5.22.02-5.22l1.2-.79.29.31-1.07.69v5.01c.01 1.6.78 2.88 2.25 2.88z",
  fill: "#fff"
});

function SvgCru(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "98f3662eb5b5aee4cec15bcfa251730e.svg";
export { SvgCru as ReactComponent };